import React from 'react'
import './footer.css'
import {GrFacebookOption} from 'react-icons/gr'
import {ImTwitter} from 'react-icons/im'
import {AiOutlineLinkedin} from 'react-icons/ai'
import {AiOutlineInstagram} from 'react-icons/ai'

const Footer = () => {

    let year = new Date().getFullYear();

  return (
    <footer>
      <a href="#" className='footer__logo'>EGATOR</a>

      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href="https://facebook.com"><GrFacebookOption/></a>
        <a href="https://twitter.com/simonmuruka"><ImTwitter/></a>
        <a href="https://instagram.com/gentle_dee"><AiOutlineInstagram/></a>
        <a href="https://linkedin.com/in/simon-wandera-b27b22215/"><AiOutlineLinkedin/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; {year} Simon Muruka. All rights reserved</small>
      </div>
    </footer>
  )
}

export default Footer
